import { MarketChart } from "./MarketChart";
import { useEffect } from "react";
import { Hero } from "./Hero";
import { LiveStats } from "./LiveStats";
import { WhatItIs } from "./WhatItIs";
import { Pledge } from "./Pledge";
import { PairedWithEth } from "./PairedWithEth";

export function HomePage() {
  useEffect(() => {
    document.title = "$TISM, a memecoin for autism acceptance";
  }, []);

  return (
    <>
      <Hero />
      <LiveStats />
      <MarketChart />
      <WhatItIs />
      <Pledge />
      <PairedWithEth />
    </>
  );
}
